import { useTheme } from "@emotion/react";
import { IconButton, styled } from "@mui/material";
import React from "react";

const CustomIconButton = styled(IconButton, {
    shouldForwardProp: (prop) => prop !== "themeColor" && prop !== "transparency"
})(({theme, themeColor, transparency}) => ({
    backgroundColor: themeColor ? themeColor.main : theme.palette.primary.main,
    color: theme.palette.getContrastText(themeColor ? themeColor.main : theme.palette.primary.main),
    opacity: transparency,
    transition: 'all 0.25s',

    "&:hover": {
        backgroundColor: themeColor ? themeColor.dark : theme.palette.primary.dark,
        opacity: '1'
    },
    "&:disabled": {
        backgruondColor: theme.palette.grey
    }
}));

const ContainedIconButton = React.forwardRef(function ContainedIconButton(props, ref) {
    const theme = useTheme();
    const transparency = theme.opacities[props.transparent ? 2 : 0];

    return (
        <CustomIconButton {...props} transparency={transparency} ref={ref} />
    )
});

export default ContainedIconButton;